import * as React from 'react';
import * as I18n from 'i18n-js';
import URLHelpers from './shared/url_helpers';
import { trackInteraction } from '@reverbdotcom/commons/dist/tracker';
import Location from '../lib/wrapped_location';
import PacklinkModal from './packlink_modal';
import { ChildProps, graphql, DataValue } from 'react-apollo';
import gql from 'graphql-tag';
import {
  CorePacklinkShippingLabelButton,
  core_apimessages_PacklinkShipment_Status as PacklinkShipmentStatus,
} from '../schemas/rql';

interface ExternalProps {
  orderId: string;
}

export type Props = ChildProps<ExternalProps, CorePacklinkShippingLabelButton.Query>;

export const COMPONENT_NAME = 'PacklinkShippingLabelButton';

export function PacklinkShippingLabelButton(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { order } = props.data;
  const packlinkShipment = optionalPacklinkShipment(order);

  usePacklinkShipmentStatus(props.data);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function onClick() {
    openModal();
    trackClick();
  }

  function trackClick() {
    trackInteraction({
      componentName: COMPONENT_NAME,
      url: Location.href,
      type: 'Order',
      entityId: props.orderId,
    });
  }

  function shippingLabelButton() {
    if (packlinkShipment.status === PacklinkShipmentStatus.SUCCESS) {
      return editShippingLabelLink();
    }

    return getShippingLabelButton();
  }

  function editShippingLabelLink() {
    return (
      <a
        href={URLHelpers.packlinkShippingLabel(packlinkShipment.reference)}
        className="button button--green button--mini"
        target="_blank"
        rel="noopener noreferrer"
      >
        {I18n.t('discovery.packlink.editShippingLabel')}
      </a>
    );
  }

  function getShippingLabelButton() {
    return (
      <button
        type="button"
        onClick={onClick}
        className="button button--green button--mini"
      >
        {I18n.t('discovery.packlink.getShippingLabel')}
      </button>
    );
  }

  return (
    <>
      {shippingLabelButton()}
      <PacklinkModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        onDraftSuccess={closeModal}
        orderId={props.orderId}
        order={order}
      />
    </>
  );
}

export function usePacklinkShipmentStatus(data: DataValue<CorePacklinkShippingLabelButton.Query>) {
  const packlinkShipment = optionalPacklinkShipment(data.order);

  const startPolling = data?.startPolling;
  const stopPolling = data?.stopPolling;

  React.useEffect(() => {
    if ([PacklinkShipmentStatus.FAILED, PacklinkShipmentStatus.SUCCESS].includes(packlinkShipment.status)) {
      stopPolling();
    }
    startPolling(500);
  }, [packlinkShipment, startPolling, stopPolling]);
}

function optionalPacklinkShipment(order: CorePacklinkShippingLabelButton.Order): CorePacklinkShippingLabelButton.PacklinkShipment {
  if (order?.packlinkShipment) {
    return order.packlinkShipment;
  }
  return {};
}

const withQuery = graphql<ExternalProps, {}>(
  gql`
  query Core_Packlink_ShippingLabelButton($id: String) {
    order(input: { id: $id }) {
      packlinkShipment {
        status
        reference
      }
    }
  }
  `,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        variables: {
          id: ownProps.orderId,
        },
      };
    },
  },
);

export default withQuery(PacklinkShippingLabelButton);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/packlink_shipping_label_button.tsx